import { useMemo } from "react";
import { editorBlocksLibrary } from "../index";
import { Platform } from "../../lib/register-block";


export default function useLibraryCompatibleBlocks(platform: Platform, cellSize?: number) {
  const blocks = useMemo(() => {
    return Object.values(editorBlocksLibrary)
      .filter(b => !!b?.config?.Icon)
      .filter(b => {
        const compatibility = b?.[platform]?.compatibility?.rowBlock;

        if (compatibility === true) return true;

        if (typeof compatibility === "object") {
          if (!cellSize) return true;
          return cellSize >= (compatibility.minSize || 1);
        }
        return false;
      });
  }, [editorBlocksLibrary, cellSize]);

  return blocks || [];
}
